class BESSAppProjectDocsEvidenceSidebar extends BESSAppBase {

    constructor() {
        super();
        this.docsProgressText = $('.app-docs-progress-text');
        this.progress = $('.app-docs-progress')
    }

    updateState(state) {
        this.docsProgressText.text('' + state.completed_credit + '/' + state.total_credit);
        this.progress.css({'width': '' + state.progress + '%'});

        $('.floorplans_completed').text('' + state.floorplans_completed);
        $('.docs_completed').text('' + state.completed);

        let hasPassedDocsEvidence = state.has_passed && state.progress >= 100;
        $('.app-sidebar-category-docs-evidence .app-section-docs-evidence-progress')
            .addClassIf('app-category-has-passed', hasPassedDocsEvidence)
            .addClassIf('app-category-has-failed', !hasPassedDocsEvidence);
        $('.app-sidebar-category-docs-evidence .app-category-pass-fail-indicator')
            .addClassIf('app-category-has-passed', hasPassedDocsEvidence)
            .addClassIf('app-category-has-failed', !hasPassedDocsEvidence);
    }
}